import CopyInput from "./CopyInput";

export default CopyInput;
